<template>
  <div>
    <div id="LouisianaLedge">
      <b-container>
        <div class="header-wrappper">
          <h1 class="section-title">Viva Victory ledge</h1>
          <div class="line"></div>
          <p>
            Looking for something new and unique for family, friends, clients or
            coworkers? The Viva Victory Ledge provides two unique vantage
            points:
          </p>
        </div>
        <b-row>
          <b-col lg="5" md="12" class="left">
            <img
              src="@/assets/images/PartyAreas/map-patio-boxes.png"
              alt="Map"
            />
            <img
              style="width: 80%; margin: 20px auto;"
              src="@/assets/images/PartyAreas/VIva_Victory_Ledge_Logo.png"
              alt=""
            />
            <div class="legal-text">
              <p>
                Please note, all seat locations, game availability, and access
                to benefits are subject to change. Seating capacity as well as
                food and beverage options may be restricted and/or vary
                throughout the 2024 season.
              </p>
            </div>
          </b-col>
          <b-col lg="7" md="12">
            <div class="right">
              <div>
                <div class="image">
                  <img
                    src="@/assets/images/LouisianaLedge/group-tickets.png"
                    alt="Ledge Tables"
                  />
                </div>
                <h3 class="subtitle">Ledge Tables</h3>
                <p class="louisiana-para">
                  Enjoy a vantage point overlooking Left Field from private
                  tables of 4. Hot dogs, snacks and complimentary beverages,
                  including Coca-Cola products, beer and wine, are all included
                  in the ticket price. Available to groups of 8 or more for
                  single games or purchase the table of 4 as a part of a Season
                  Membership.
                </p>
              </div>
              <div>
                <div class="image">
                  <img
                    src="@/assets/images/LouisianaLedge/patio-boxes.png"
                    alt="Patio Boxes"
                  />
                </div>
                <h3 class="subtitle">Patio Boxes</h3>
                <p class="louisiana-para">
                  Bring your group of 10-22 to the ballpark and enjoy oversized
                  cushioned seats with a private TV as well as complimentary
                  snacks, hot dogs, and beverages, including Coca-Cola products,
                  beer and wine. Additional catering options available to
                  complete your outing!
                </p>
              </div>
            </div>
            <div class="buy-now">
              <a
                href="https://www.mlb.com/rays/tickets/group-tickets/left-field-ledge"
                target="_blank"
              >
                <button class="btn btn-secondary">Buy Now</button></a
              >
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <Banner bannerDivider="eighth" />
  </div>
</template>

<script>
import Banner from "@/components/sections/Banner/Banner";

export default {
  name: "LouisianaLedge",
  components: {
    Banner,
  },
};
</script>
<style lang="scss" scoped>
#LouisianaLedge {
  padding-block: 150px 100px;
  background-image: url("~@/assets/images/welcome/bgImage_gray.jpg");
  background-size: cover;
  @media only screen and (max-width: $md) {
    padding-block: 50px;
  }
  .header-wrappper {
    p {
      margin: 10px 0 30px;
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 145%;
      color: #161e26;
    }
    .line {
      background-color: $yellow;
      width: 737px;
      height: 5px;
      margin: 15px 0 1em;
      @media only screen and (max-width: $lg) {
        width: 528px;
        margin: 15px auto;
      }
      @media only screen and (max-width: $sm) {
        width: 90%;
      }
    }
    h1 {
      font-family: "Antique Olive";
      font-style: normal;
      font-weight: 700;
      font-size: 35px;
      line-height: 80%;
      text-transform: uppercase;
      color: #00285e;
      @media only screen and (max-width: $lg) {
        line-height: 1em;
        text-align: center;
        font-size: 25px;
      }
    }
  }
  .left {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: stretch;
    img {
      margin: 10px 20px 10px 0;
    }
    .legal-text {
      font-family: "Futura";
      font-style: italic;
      font-weight: 500;
      font-size: 14px;
      line-height: 145%;
      align-items: center;
      color: #161e26;
      margin-top: auto;
      padding-block: 10px;
    }
  }
  .image {
    overflow: hidden;
    display: flex;
    justify-content: center;

    img {
      width: calc(100% + 100px);
      max-width: unset;
    }
  }
  .right {
    font-family: "Futura";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 145%;
    color: #dad9d7;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    gap: 20px;
    h3 {
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 145%;
      text-transform: uppercase;
      color: #00285e;
      margin-top: 20px !important;
    }
    p {
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 145%;
      color: #161e26;
      margin-bottom: 20px !important;
    }
  }
  .buy-now {
    text-align: center;
    button {
      width: 400px;
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      text-transform: uppercase;
      color: #00285e;
      border: 2px solid $yellow;
      border-radius: 50px;
      padding: 10px 40px;
      background: $yellow;
    }
  }
}
</style>
